// react-table depends on spreading props; we could name them explicitly but this component might
// break if the shape of the return value from row.getRowProps() changes
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Cell, Row } from 'react-table';

import { CompactNumberCell } from '@trqk/components';
import { formatNumberCompact } from '@trqk/utils';

import { sumIncludedDetections } from '../../utils';
import { COLUMN_IDS, summarizeRowsAbove } from '../../constants';

interface AggregatedGapCellProps {
    cell: Cell<TrqkGapChannelAudio, number>;
    row: Row<TrqkGapChannelAudio>;
}

/**
 * For summary rows, this component displays a formatted count of detections for sub-rows that have
 * been selected to include in the report.
 * For non-summary rows, this component displays a <CompactNumberCell />.
 */
export function AggregatedGapCell({
    cell,
    row,
}: AggregatedGapCellProps): JSX.Element | string {
    if (row.subRows.length > summarizeRowsAbove) {
        const detections = sumIncludedDetections(row.subRows);
        const performances =
            row.values?.[COLUMN_IDS.PERFORMANCES]?.performances ?? 0;

        return <>{formatNumberCompact(detections - performances)}</>;
    }

    return <CompactNumberCell cell={cell} />;
}
